module.exports = __webpack_public_path__ + "market/static/img/lightNew.dd08088.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/award/lightNew.png
// module id = gjwW
// module chunks = 1